import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Result } from "@murm/ant";
import styles from "./StatusPages.module.css";

const ErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { message } = location.state || {
    message: "An unknown error occurred.",
  };

  return (
    <div className={styles.errorPage}>
      <Result
        status="error"
        title="Sorry! We've encountered an error."
        subTitle={message}
        extra={
          <Button type="primary" onClick={() => navigate("/")}>
            Go back home
          </Button>
        }
      />
    </div>
  );
};

export { ErrorPage };
